import { useEffect } from 'react';
import { useLocation, useNavigation } from 'react-router-dom';


export function RouteLogger() {
  const location = useLocation();
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.state === 'idle') {
      console.log('📍 Navigated to:', location.pathname, location.search);
    }
  }, [location, navigation]);

  return null;
}